// SPDX-License-Identifier: AGPL-3.0-or-later

/**
 * Sheets, phone menus and dialogs each push a history entry so the phone's Back closes them. When
 * one closes by itself it steps back over that entry, and the popstate that follows is not the
 * person pressing Back: nothing else may close on it. One count for all of them, because a menu
 * item that opens a dialog (Close pull request?) otherwise loses the dialog the moment it opens.
 */
let pending = 0;
let fallback: ReturnType<typeof setTimeout> | null = null;

function settle(): void {
	pending = 0;
	if (fallback !== null) clearTimeout(fallback);
	fallback = null;
	window.removeEventListener('popstate', onPopState);
}

function onPopState(): void {
	// Counted down just after this popstate's own listeners ran, so every one of them sees it.
	setTimeout(() => {
		if (pending <= 1) settle();
		else pending -= 1;
	}, 0);
}

export function stepBackQuietly(history: {back(): void}): void {
	if (pending === 0) window.addEventListener('popstate', onPopState);
	pending += 1;
	// Browsers may fold quick steps into one popstate: never stay quiet for long.
	if (fallback !== null) clearTimeout(fallback);
	fallback = setTimeout(settle, 1000);
	history.back();
}

/** True while the popstate a closing sheet, menu or dialog caused is being handled. */
export function isQuietStepBack(): boolean {
	return pending > 0;
}
